// Strictly typed TicketList.tsx
import React, { useState, FC } from 'react'
import { Card, Col, Alert, Form, Button, Toast, ToastContainer } from 'react-bootstrap'
import Moment from 'react-moment'
import CommentModal from './CommentModal'
import './style.css'

interface Ticket {
  reference_number: string
  status: string
  expected_delivery_time: string
  [key: string]: any
}

interface TicketListProps {
  tickets: Ticket[]
}

export const TicketList: FC<TicketListProps> = ({ tickets }) => {
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [showModal, setShowModal] = useState<boolean>(false)
  const [selectedTicket, setSelectedTicket] = useState<Ticket | null>(null)
  const [showThanks, setShowThanks] = useState<boolean>(false)

  const filteredTickets = tickets.filter(ticket =>
    ticket.reference_number.toLowerCase().includes(searchTerm.toLowerCase()) ||
    ticket.status.toLowerCase().includes(searchTerm.toLowerCase())
  )

  const handleCommentClick = (ticket: Ticket) => {
    setSelectedTicket(ticket)
    setShowModal(true)
  }

  const handleSubmitComment = (referenceNumber: string, comment: string) => {
    console.log(`Comment for ${referenceNumber}:`, comment)
    // TODO: Submit to API
    setShowThanks(true)
  }

  return (
    <div className="ticket-list-container position-relative">
      <Form className="mb-3">
        <Form.Control
          type="text"
          placeholder="Search by Ticket Number or Status"
          value={searchTerm}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchTerm(e.target.value)}
        />
      </Form>

      {filteredTickets.length === 0 ? (
        <Alert variant="info" className="text-center">
          No matching tickets found.
        </Alert>
      ) : (
        <div className="ticket-list ticket-list-scroll">
          {filteredTickets.map((ticket, index) => (
            <Card key={index} className="ticket-card mt-3 shadow-sm border-0">
              <Card.Header className="bg-dark text-white d-flex justify-content-between align-items-center">
                <h5 className="mb-0">{ticket.reference_number}</h5>
                {/*<Button*/}
                {/*  variant="outline-light"*/}
                {/*  size="sm"*/}
                {/*  onClick={() => handleCommentClick(ticket)}*/}
                {/*>*/}
                {/*  Comment*/}
                {/*</Button>*/}
              </Card.Header>

              <Card.Body>
                <Col className="d-flex align-items-center mb-2">
                  <div className={`status-circle status-circle-${ticket.status?.toLowerCase()} me-2`}>
                    {ticket.status?.[0]?.toUpperCase() || '-'}
                  </div>
                  <p className="mb-0">
                    <strong>Status:</strong>&nbsp;{ticket.status}<br />
                    <strong>Expected Delivery:</strong>{' '}
                    <Moment format="DD-MM-YYYY hh:mm A" local>
                      {ticket.expected_delivery_time}
                    </Moment>
                  </p>
                </Col>
              </Card.Body>
            </Card>
          ))}
        </div>
      )}

      {selectedTicket && (
        <CommentModal
          show={showModal}
          handleClose={() => setShowModal(false)}
          handleSubmit={handleSubmitComment}
          ticket={selectedTicket}
        />
      )}

      <ToastContainer position="bottom-end" className="p-3">
        <Toast onClose={() => setShowThanks(false)} show={showThanks} delay={3000} autohide>
          <Toast.Header>
            <strong className="me-auto">Thank You</strong>
          </Toast.Header>
          <Toast.Body>Your comment has been submitted successfully!</Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  )
}

export default TicketList
